import { z } from "zod";

export const prayerSchema = z
	.object({
		date: z.string(),
	})
	.catchall(z.string());

export const prayerArraySchema = z.array(prayerSchema);

export type Prayer = z.infer<typeof prayerSchema>;
export type PrayerArray = z.infer<typeof prayerArraySchema>;
